import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminDoctorsPage } from './admin-doctors';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminDoctorsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminDoctorsPage),
    DirectivesModule
  ],
})
export class AdminDoctorsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-doctors/admin-doctors.module.ts